import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "weChatMsgWindowContainer" }
const _hoisted_2 = { class: "weChatMsgWindowHeader" }
const _hoisted_3 = { class: "weChatMsgWindowHeader--name" }
const _hoisted_4 = { class: "weChatMsgWindowHeader--button" }
const _hoisted_5 = { class: "weChatMsgCard" }
const _hoisted_6 = { class: "weChatMsgCard--header" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "weChatMsgCard--date" }, null, -1)
const _hoisted_8 = { class: "weChatMsgCard--content" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "wechatReverseClass"
}
const _hoisted_12 = {
  key: 1,
  class: "wechatReverseClass"
}
const _hoisted_13 = {
  class: "infinite-list",
  style: {"overflow":"auto"}
}
const _hoisted_14 = { style: {"padding":"5px"} }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ref, computed, watchEffect, onMounted } from "vue";
import { WeChatActions, WeChatGetters } from "@/store/modules/weChat";
import { WeChatMsg } from "@/store/modules/weChat/types";
import { More, User } from "@element-plus/icons-vue";
import { wechatStaticUrl } from "@/requests";
import ReverseElementScroll from "@/utils/scrollerHijack";


import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "WeChatMsgWindow",
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const route = useRoute();
const store = useStore();
const showParticipants = ref<boolean>(false)
const weChatMsgContainer = ref<HTMLElement | null>(null);

const wechatMsgListRef = ref<HTMLElement | null>(null);
onMounted(() => {
    const msgListElement = wechatMsgListRef.value; // 获取元素的引用

    if (msgListElement) {
        ReverseElementScroll(msgListElement)
    }
})

const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const wechatIdCom = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getMeId}`];
});

const isMsgLoading = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getIsMsgListLoading}`];
});

const selectedSession = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getSelectedSession}`];
});

const msgGroup = computed(() => {
    if (selectedSession.value !== null) {
        return store.getters[`weChat/${WeChatGetters.getMsgGroupByName}`](selectedSession.value.strUsrName);
    } else {
        return [];
    }
});

const headerName = computed(() => {
    return selectedSession.value ? selectedSession.value.strNickName : "";
});

const isCurrentMsgListAllLoaded = computed(() => {
    if (selectedSession.value !== null) {
        return store.getters[`weChat/${WeChatGetters.getIsMsgListAllLoadedByName}`](selectedSession.value.strUsrName);
    } else {
        return false;
    }
});

const shouldUpdate = computed(() => {
    return (!isCurrentMsgListAllLoaded.value && !isMsgLoading.value && selectedSession.value !== null);
});

const participantsList = computed(() => {
    return selectedSession.value === null ? [] : store.getters[`weChat/${WeChatGetters.getChatroomGroupByName}`](selectedSession.value.strUsrName);
});
const isParticipantsAllLoaded = computed(() => {
    return selectedSession.value === null ? false : store.getters[`weChat/${WeChatGetters.getIsPaticipantsAllLoadedByName}`](selectedSession.value.strUsrName);
});
const isParticipantsLoading = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getIsPaticipantsLoading}`];
});

const handleScroll = () => {
    if (wechatMsgListRef.value !== null && weChatMsgContainer.value !== null) {
        return wechatMsgListRef.value.scrollTop + weChatMsgContainer.value.scrollHeight >= wechatMsgListRef.value.scrollHeight
    } else {
        return false
    }
}

const loadMsgList = () => {
    if (shouldUpdate.value && handleScroll()) {
        const projId = projectId.value;
        const uid = targetId.value;
        const wechatId = wechatIdCom.value;
        try {
            const name = selectedSession.value.strUsrName;
            store.dispatch(`weChat/${WeChatActions.asyncGetMsgListByUidAndName}`, { projId, uid, wechatId, name });
        } catch (err) {
            console.log(err)
        }
    }
}

const loadParticipantsList = () => {
    if (!isParticipantsAllLoaded.value && !isParticipantsLoading.value) {
        const projId = projectId.value;
        const uid = targetId.value;
        const wechatId = wechatIdCom.value;
        const chatroomName = selectedSession.value.strUsrName
        if (selectedSession.value.strUsrName.includes("@chatroom")) {
            store.dispatch(`weChat/${WeChatActions.asyncGetParticipantsByChatroomName}`, { projId, uid, wechatId, chatroomName });
        }
    }
}
const handleClickForChatroom = () => {
    const projId = projectId.value;
    const uid = targetId.value;
    const wechatId = wechatIdCom.value;
    const chatroomName = selectedSession.value.strUsrName
    if (selectedSession.value.strUsrName.includes("@chatroom")) {
        showParticipants.value = true;
        store.dispatch(`weChat/${WeChatActions.asyncGetParticipantsByChatroomName}`, { projId, uid, wechatId, chatroomName });
    }
}


const getMsgSender = (msg: WeChatMsg): string => {
    if (msg.IsSender === 1) {
        return "我";
    }
    if (msg.StrTalker.includes("@chatroom")) {
        return msg.senderStr;
    } else {
        return selectedSession.value.strNickName;
    }
}


watchEffect(() => {
    if (shouldUpdate.value && msgGroup.value.msgList.length === 0) {
        const projId = projectId.value;
        const uid = targetId.value;
        const wechatId = wechatIdCom.value;
        try {
            const name = selectedSession.value.strUsrName;
            store.dispatch(`weChat/${WeChatActions.asyncGetMsgListByUidAndName}`, { projId, uid, wechatId, name });

            while (handleScroll() && shouldUpdate.value) {
                loadMsgList()
            }

        } catch (err) {
            console.log(err)
        }
    }
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_unref(headerName)), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          link: "",
          icon: _unref(More),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClickForChatroom()))
        }, null, 8, ["icon"])
      ])
    ]),
    _createElementVNode("div", {
      class: "weChatMsgWindowContent",
      ref_key: "weChatMsgContainer",
      ref: weChatMsgContainer
    }, [
      _createElementVNode("div", {
        onScroll: loadMsgList,
        class: "weChatMsgList wechatReverseClass",
        ref_key: "wechatMsgListRef",
        ref: wechatMsgListRef
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(msgGroup).msgList, (msg) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "weChatMsgContent wechatReverseClass",
            key: msg.Sequence
          }, [
            (_openBlock(), _createElementBlock("div", {
              class: "weChatMsg",
              key: msg.Sequence
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", null, _toDisplayString(getMsgSender(msg)), 1)
                ]),
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  (msg.Type == 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_el_image, {
                          style: {"width":"70px","height":"70px"},
                          src: _unref(wechatStaticUrl) + msg.StrContent,
                          "preview-src-list": [_unref(wechatStaticUrl) + msg.StrContent],
                          title: "点击查看大图"
                        }, null, 8, ["src", "preview-src-list"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(msg.StrContent), 1))
                ])
              ])
            ]))
          ]))
        }), 128)),
        (_unref(isMsgLoading))
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "加载中......"))
          : _createCommentVNode("", true),
        (_unref(isCurrentMsgListAllLoaded))
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, "------已加载全部-------"))
          : _createCommentVNode("", true)
      ], 544)
    ], 512),
    _createVNode(_component_el_dialog, {
      class: "show-participants",
      modelValue: showParticipants.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showParticipants).value = $event)),
      title: "群组成员"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(participantsList).userList, (user) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  span: 4,
                  key: user
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, {
                      class: "userCard",
                      "body-style": { padding: '10px', height: '100px', width: '100px' },
                      shadow: "never"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(User))
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(user.NickName), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          (_unref(isParticipantsLoading))
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, "加载中......"))
            : _createCommentVNode("", true),
          (_unref(isParticipantsAllLoaded))
            ? (_openBlock(), _createElementBlock("p", _hoisted_16, "------已加载全部-------"))
            : _createCommentVNode("", true)
        ])), [
          [_directive_infinite_scroll, loadParticipantsList]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})